cc.Class({
    extends: cc.Component,

    properties: {
        nodesBundle1: [cc.Node],
        nodesBundle2: [cc.Node],
        deactivateOnZeroOpacity: true,
        blend: {
            min: 0,
            max: 1,
            default: 0,
            notify: function() {
                this.applyBlend();
            }
        }
    },

    applyBlend () {
        this._applyBlendToNodes(this.nodesBundle1, this.blend);
        this._applyBlendToNodes(this.nodesBundle2, 1 - this.blend);
    },

    _applyBlendToNodes(nodes, blendValue) {
        nodes.forEach(item => {
            item.opacity = blendValue * 255;
            if (this.deactivateOnZeroOpacity) {
                item.active = blendValue > 0;
            }
        });
    }
});
